/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Customer Content API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContentItemResponse
 */
export interface ContentItemResponse {
    /**
     * 
     * @type {string}
     * @memberof ContentItemResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ContentItemResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ContentItemResponse
     */
    contents: string;
}

export function ContentItemResponseFromJSON(json: any): ContentItemResponse {
    return ContentItemResponseFromJSONTyped(json, false);
}

export function ContentItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentItemResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'contents': json['contents'],
    };
}

export function ContentItemResponseToJSON(value?: ContentItemResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'contents': value.contents,
    };
}


